export default {
  a: {
    code: 'A',
    description:
      'A - AIR PRIO',
  },
  b: {
    code: 'B',
    description: 'B - S.A.L',
  },
  c: {
    code: 'C',
    description:
      'C - SURFACE',
  },
  d: {
    code: 'D',
    description:
      'D - SURFACE PRIO',
  },
};
